module.exports = __webpack_public_path__ + "media/img/vca/nomh2-cb735fc5b1fb0283e7a1790638148311.png";